import i18n from "../i18n";

export const roles = () => [
  { text: i18n.t("lbl.admin"), value: "admin" },
  { text: i18n.t("lbl.auditor"), value: "auditor" },
  { text: i18n.t("lbl.user"), value: "user" },
  { text: i18n.t("lbl.reseller"), value: "reseller" },
  { text: i18n.t("lbl.retailer"), value: "retailer" },
  { text: i18n.t("lbl.mct"), value: "mct" },
];

export const unbox = () => [
  { text: i18n.t("lbl.boxed"), value: "false" },
  { text: i18n.t("lbl.unboxed"), value: "true" },
];

export const editions = () => [
  { text: i18n.t("lbl.kids"), value: "kids" },
  { text: i18n.t("lbl.home"), value: "home" },
  { text: i18n.t("lbl.pro"), value: "pro" },
];

export const wireless = () => [
  { text: i18n.t("lbl.iax200"), value: "iax200" },
  { text: i18n.t("lbl.i7265"), value: "i7265" },
  { text: i18n.t("lbl.mt7915e"), value: "mt7915e" },
  { text: i18n.t("lbl.rt28xx"), value: "rt28xx" },
  { text: i18n.t("lbl.unknown"), value: "unknown" },
  { text: i18n.t("lbl.none"), value: "" },
];

export const licences = () => [
  { text: i18n.t("lbl.licenced"), value: "licenced" },
  { text: i18n.t("lbl.prolonged"), value: "prolonged" },
  { text: i18n.t("lbl.unlicenced"), value: "unlicenced" },
];

export const yesno = () => [
  { text: i18n.t("lbl.yes"), value: true },
  { text: i18n.t("lbl.nay"), value: false },
];
